import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class LoginTrendAnalysisService {

  constructor(private dataService: DataService) { }

  getCurrentMonthLoginActivity() {
    return this.dataService.getRecord('/api/WebLoginActivity/getCurrentMonthLoginActivity');
  }
  getCurrentMonthMobileLoginActivity() {
    return this.dataService.getRecord('/api/mobileloginactivity/getCurrentMonthMobileLoginActivity');
  }
  getCurrentMonthCoverageActivity() {
    return this.dataService.getRecord('/api/AddressSearchHistory/getCurrentMonthCoverageActivity');
  }
  getSelectedMonthLoginActivity(monthValue: string) {
    return this.dataService.getRecord('/api/WebLoginActivity/getSelectedMonthLoginActivity/' + monthValue);
  }
  getSelectedMonthCoverageActivity(monthValue: string) {
    return this.dataService.getRecord('/api/AddressSearchHistory/getSelectedMonthCoverageActivity/' + monthValue);
  }
}
